import { useCallback, useEffect, useState } from "react";
import useProfileStore from "../../store/patient/profileStore";
import { fetchDepositBalance } from "../../utils/patients/fetchDepositHistory";

// Single source of truth for the patient's available (deposit/wallet) balance,
// sourced from the account_deposits ledger via patient/:id/deposit-balance.
// NOTE: `profile.balance` is the net *bills* balance (negative when owing) — do
// NOT use it for the wallet. Use this hook everywhere the wallet is shown.
export default function useWalletBalance() {
  const { profile } = useProfileStore();
  const [balance, setBalance] = useState(
    typeof profile?.depositBalance === "number" ? profile.depositBalance : 0
  );

  const refetch = useCallback(async () => {
    if (!profile?.id) return;
    try {
      const res = await fetchDepositBalance(profile.id);
      const value = Number(res?.data?.balance);
      if (!Number.isNaN(value)) setBalance(value);
    } catch (err) {
      console.error("Error fetching wallet balance:", err);
    }
  }, [profile?.id]);

  useEffect(() => {
    refetch();
  }, [refetch]);

  return { balance, refetch };
}
